import { IPartner } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownOption from 'components/Common/DropdownOption';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TableContainer from 'components/Common/TableContainer';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { COLORS_RANK_NEWS, NEWS_TYPE, RANK_NEWS_OPTIONS, SECTION_KEYWORD, SECTION_KEYWORD_OPTIONS, STATUS_NEWS_OPTIONS, TYPE_NEWS_OPTIONS } from 'helpers/constans';
import { filterMediaOptions, formatNumberWithCommas } from 'helpers/format';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { deleteNewsMulti, downloadExcelTrackingNews, getAllCategory, getAllOperators, getAllPartners, getAllTagNews, getChartDailySearchVolumeRankingKeywordNews, getChartRankingKeywordNews, getSummariesArticleTrackings, getArticleTrackings as onGetArticleTrackings, postPublishUrlNews, putCategoryNews, putKeywordNews, putTagNews } from 'store/thunks';
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import HighlightText from '../Components/HighlightText';
import ImportArticleForm from '../Components/ImportArticleForm';
import ImportMediaArticleForm from '../Components/ImportMediaArticleForm';
import NestingFilter from '../Components/NestingFilter';
import ChartToBase64 from './ChartToBase64';
import RankingChart from './RankingChart';
import DropdownStatus from 'components/Common/DropdownStatus';
import { IOperator } from 'api/types/_operator';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { ITagNews } from 'api/types/_master';
import DropdownMultiOption from 'components/Common/DropdownMultiOption';
import Hashtag from 'components/Common/Hashtag';
import TableTrackingNewsContainer from 'components/Common/TableTrackingNewsContainer';

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'click_count';

const TrackingNewsList = ({ isPage = true }: any) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();
  const modalBodyInnerRef = useRef<any>(null);

  const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const SECTION_KEYWORD_OPTIONS_LANG = SECTION_KEYWORD_OPTIONS?.map((item: any) => ({
    value: `${item?.value}`,
    label: t(item?.label),
  }));

  const TYPE_NEWS_OPTIONS_LANG = TYPE_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const RANK_NEWS_OPTIONS_LANG = [{ value: '2', label: 'Included' }, { value: '1', label: 'Not Included' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const IMPRESSION_OPTIONS_LANG = [{ value: '1', label: 'Approved' }, { value: '0', label: 'Not Approved' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const SM_RANK_NEWS_OPTIONS_LANG = RANK_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));


  const END_DATE = `${moment().format("Y-MM-DD")}`;

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    keyword: withDefault(StringParam, ''),
    title: withDefault(StringParam, ''),
    partner_news_url: withDefault(StringParam, ''),
    partner_id: withDefault(StringParam, ''),
    partner_code_id: withDefault(StringParam, ''),
    admin_id: withDefault(StringParam, ''),
    exposure_rank_start: withDefault(StringParam, ''),
    exposure_rank_end: withDefault(StringParam, ''),
    affiliate_rank_start: withDefault(StringParam, ''),
    affiliate_rank_end: withDefault(StringParam, ''),
    impression_count_start: withDefault(StringParam, ''),
    impression_count_end: withDefault(StringParam, ''),
    click_count_start: withDefault(StringParam, ''),
    click_count_end: withDefault(StringParam, ''),
    ctr_count_start: withDefault(StringParam, ''),
    ctr_count_end: withDefault(StringParam, ''),
    survival_days_start: withDefault(StringParam, ''),
    survival_days_end: withDefault(StringParam, ''),
    daily_search_volume_start: withDefault(StringParam, ''),
    daily_search_volume_end: withDefault(StringParam, ''),
    news_section_rank_start: withDefault(StringParam, ''),
    news_section_rank_end: withDefault(StringParam, ''),
    pa_index_start: withDefault(StringParam, ''),
    pa_index_end: withDefault(StringParam, ''),
    news_type: withDefault(StringParam, ''),
    section: withDefault(StringParam, ''),
    category_id: withDefault(StringParam, ''),
    partner_news_expose_flg: withDefault(StringParam, ''),
    search_media_rank_type: withDefault(StringParam, ''),
    published_start: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    published_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    date_start: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    date_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    tag_ids: withDefault(StringParam, ''),
  });

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");
  const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");
  const [urlSearch, setUrlSearch] = useState<string>(query?.partner_news_url || "");

  const [startExposureSearch, setStartExposureSearch] = useState<string>(query?.exposure_rank_start || "");
  const [endExposureSearch, setEndExposureSearch] = useState<string>(query?.exposure_rank_end || "");

  const [startPAMediaRankSearch, setStartPAMediaRankSearch] = useState<string>(query?.affiliate_rank_start || "");
  const [endPAMediaRankSearch, setEndPAMediaRankSearch] = useState<string>(query?.affiliate_rank_end || "");

  const [startImpressionSearch, setStartImpressionSearch] = useState<string>(query?.impression_count_start || "");
  const [endImpressionSearch, setEndImpressionSearch] = useState<string>(query?.impression_count_end || "");

  const [startClickSearch, setStartClickSearch] = useState<string>(query?.click_count_start || "");
  const [endClickSearch, setEndClickSearch] = useState<string>(query?.click_count_end || "");

  const [startCtrSearch, setStartCtrSearch] = useState<string>(query?.ctr_count_start || "");
  const [endCtrSearch, setEndCtrSearch] = useState<string>(query?.ctr_count_end || "");

  const [startSurvivalDaySearch, setStartSurvivalDaySearch] = useState<string>(query?.survival_days_start || "");
  const [endSurvivalDaySearch, setEndSurvivalDaySearch] = useState<string>(query?.survival_days_end || "");

  const [startDailyVolumeSearch, setStartDailyVolumeSearch] = useState<string>(query?.daily_search_volume_start || "");
  const [endDailyVolumeSearch, setEndDailyVolumeSearch] = useState<string>(query?.daily_search_volume_end || "");

  const [startNewsSectionSearch, setStartNewsSectionSearch] = useState<string>(query?.news_section_rank_start || "");
  const [endNewsSectionSearch, setEndNewsSectionSearch] = useState<string>(query?.news_section_rank_end || "");

  const [startPAIndexSearch, setStartPAIndexSearch] = useState<string>(query?.pa_index_start || "");
  const [endPAIndexSearch, setEndPAIndexSearch] = useState<string>(query?.pa_index_end || "");

  const [rankSearch, setRankSearch] = useState<Option | null>(SM_RANK_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.search_media_rank_type)) || null);

  const [impressionSearch, setImpressionSearch] = useState<Option | null>(IMPRESSION_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.partner_news_expose_flg)) || null);

  const [typeNewsSearch, setTypeNewsSearch] = useState<Option | null>(TYPE_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.news_type)) || null);

  const [sectionSearch, setSectionSearch] = useState<Option | null>(!!(query?.section || query?.category_id) ? { value: query?.section || query?.category_id, label: '' } : null);

  const [mediaSearch, setMediaSearch] = useState<Option | null>(!!query?.partner_id ? { value: query?.partner_id, label: '' } : null);

  const [adminSearch, setAdminSearch] = useState<Option | null>(!!query?.admin_id ? { value: query?.admin_id, label: '' } : null);

  const [tagsSearch, setTagsSearch] = useState<Option[] | null>(null);

  const [mediaSectionSearch, setMediaSectionSearch] = useState<Option | null>(!!query?.partner_code_id ? { value: query?.partner_code_id, label: '' } : null);

  const [datePublishedRangeSearch, setDatePublishedRangeSearch] = useState<any[]>([query?.published_start ? moment(query?.published_start, 'Y-MM-DD').toDate() : null, query?.published_end ? moment(query?.published_end || '', 'Y-MM-DD').toDate() : null]);
  const [startDatePublished, endDatePublished] = datePublishedRangeSearch;

  const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.date_start ? moment(query?.date_start, 'Y-MM-DD').toDate() : null, query?.date_end ? moment(query?.date_end || '', 'Y-MM-DD').toDate() : null]);
  const [startDate, endDate] = dateRangeSearch;

  const [boostingCategories, setBoostingCategories] = useState<Option[]>([]);

  const [isOpenImportMediaNews, setIsOpenImportMediaNews] = useState<boolean>(false);

  const [isOpenImportNews, setIsOpenImportNews] = useState<boolean>(false);

  const [isOpenChart, setIsOpenChart] = useState<boolean>(false);
  const [chart, setChart] = useState<any>(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<{ news_id: number } | null>(null);

  const [isLoadingExportFile, setIsLoadingExportFile] = useState<boolean>(false);

  const [partners, setPartners] = useState<IPartner[]>([]);
  const [operators, setOperators] = useState<IOperator[]>([]);
  const [tags, setTags] = useState<Option[]>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Tracking;

  const TrackingProperties = createSelector(
    selectLayoutState,
    (state) => ({
      articleTrackings: state.articleTrackings,
      isArticleTrackingSuccess: state.isArticleTrackingSuccess,
      isArticleTrackingLoading: state.isArticleTrackingLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { articleTrackings, error, isArticleTrackingLoading } = useSelector(TrackingProperties);

  const [summaries, setSummaries] = useState<any>({});

  const onGetSummariesArticleTrackings = (params: any) => {
    if (isArticleTrackingLoading) {
      return;
    }
    getSummariesArticleTrackings(params).then((res: any) => {
      setSummaries((_prev: any) => res?.data)
    }).catch((error) => { });
  };

  useEffect(() => {
    dispatch(onGetArticleTrackings(query));
    onGetSummariesArticleTrackings(query);
  }, [JSON.stringify(query)]);

  const searchData = () => {
    if (isArticleTrackingLoading) {
      return;
    }
    setQuery({
      ...query,
      keyword: String(keywordSearch || '').trim().replace(/\s+/g, ''),
      title: titleSearch || '',
      partner_news_url: urlSearch || '',
      partner_id: mediaSearch?.value || '',
      partner_code_id: mediaSectionSearch?.value || '',

      admin_id: adminSearch?.value || '',

      tag_ids: (tagsSearch || [])?.map((_t: any) => _t?.value)?.join(',') || '',

      exposure_rank_start: startExposureSearch || '',
      exposure_rank_end: endExposureSearch || '',

      affiliate_rank_start: startPAMediaRankSearch || '',
      affiliate_rank_end: endPAMediaRankSearch || '',

      impression_count_start: startImpressionSearch || '',
      impression_count_end: endImpressionSearch || '',

      click_count_start: startClickSearch || '',
      click_count_end: endClickSearch || '',

      ctr_count_start: startCtrSearch || '',
      ctr_count_end: endCtrSearch || '',

      survival_days_start: startSurvivalDaySearch || '',
      survival_days_end: endSurvivalDaySearch || '',

      daily_search_volume_start: startDailyVolumeSearch || '',
      daily_search_volume_end: endDailyVolumeSearch || '',

      news_section_rank_start: startNewsSectionSearch || '',
      news_section_rank_end: endNewsSectionSearch || '',

      pa_index_start: startPAIndexSearch || '',
      pa_index_end: endPAIndexSearch || '',

      search_media_rank_type: rankSearch?.value || '',
      news_type: typeNewsSearch?.value,
      partner_news_expose_flg: impressionSearch?.value || '',
      category_id: boostingCategories?.find((_s) => _s?.value === sectionSearch?.value)?.value || '',
      section: SECTION_KEYWORD_OPTIONS_LANG?.find((_s) => _s?.value === sectionSearch?.value)?.value || '',
      published_start: startDatePublished ? moment(new Date(startDatePublished)).format("Y-MM-DD") : '',
      published_end: endDatePublished ? moment(new Date(endDatePublished)).format("Y-MM-DD") : '',
      date_start: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      date_end: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      page: 1,
      time_request: + new Date()
    });
  };

  const resetData = () => {
    const queryNew = {
      title: '',
      keyword: '',
      partner_news_url: '',
      partner_id: '',
      partner_code_id: '',
      admin_id: '',
      tag_ids: '',
      exposure_rank_start: '',
      exposure_rank_end: '',
      affiliate_rank_start: '',
      affiliate_rank_end: '',
      impression_count_start: '',
      impression_count_end: '',
      click_count_start: '',
      click_count_end: '',
      ctr_count_start: '',
      ctr_count_end: '',
      survival_days_start: '',
      survival_days_end: '',
      daily_search_volume_start: '',
      daily_search_volume_end: '',
      news_section_rank_start: '',
      news_section_rank_end: '',
      pa_index_start: '',
      pa_index_end: '',
      search_media_rank_type: '',
      partner_news_expose_flg: '',
      news_type: '',
      section: '',
      category_id: '',
      published_start: `${moment().format("Y-MM-DD")}`,
      published_end: `${moment().format("Y-MM-DD")}`,
      date_start: `${moment().format("Y-MM-DD")}`,
      date_end: `${moment().format("Y-MM-DD")}`,
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: 'DESC',
      page: 1,
      time_request: + new Date(),
    };
    setQuery(queryNew, "push");
    setTitleSearch((_prev) => "");
    setUrlSearch((_prev) => "");
    setKeywordSearch((_prev) => "");
    setSectionSearch(null);
    setRankSearch(null);
    setTypeNewsSearch(null);
    setMediaSearch(null);
    setMediaSectionSearch(null);
    setAdminSearch(null);
    setTagsSearch(null);
    setImpressionSearch(null);
    setStartExposureSearch(queryNew?.exposure_rank_start);
    setEndExposureSearch(queryNew?.exposure_rank_end);
    setStartPAMediaRankSearch(queryNew?.affiliate_rank_start);
    setEndPAMediaRankSearch(queryNew?.affiliate_rank_end);
    setStartImpressionSearch(queryNew?.impression_count_start);
    setEndImpressionSearch(queryNew?.impression_count_end);
    setStartClickSearch(queryNew?.click_count_start);
    setEndClickSearch(queryNew?.click_count_end);
    setStartCtrSearch(queryNew?.ctr_count_start);
    setEndCtrSearch(queryNew?.ctr_count_end);
    setStartSurvivalDaySearch(queryNew?.survival_days_start);
    setEndSurvivalDaySearch(queryNew?.survival_days_end);
    setStartDailyVolumeSearch(queryNew?.daily_search_volume_start);
    setEndDailyVolumeSearch(queryNew?.daily_search_volume_end);
    setStartNewsSectionSearch(queryNew?.news_section_rank_start);
    setEndNewsSectionSearch(queryNew?.news_section_rank_end);
    setStartPAIndexSearch(queryNew?.pa_index_start);
    setEndPAIndexSearch(queryNew?.pa_index_end);
    setDatePublishedRangeSearch([moment(queryNew?.published_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.published_end || "", 'Y-MM-DD').toDate()]);
    setDateRangeSearch([moment(queryNew?.date_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.date_end || "", 'Y-MM-DD').toDate()]);
  };

  // Begin:: update link
  const [itemUpdateLink, setItemUpdateLink] = useState<{ id: number, link: string } | null>(null);
  const [isLoadingUpdateLink, setIsLoadingUpdateLink] = useState<boolean>(false);

  const handleUpdateLink = async () => {
    try {
      if (!itemUpdateLink) {
        return;
      }
      setIsLoadingUpdateLink((_prev) => true);
      const response: any = await postPublishUrlNews(itemUpdateLink?.id, { url: itemUpdateLink?.link });
      setIsLoadingUpdateLink((_prev) => false);
      if (response?.code === 200) {
        setItemUpdateLink((_prev) => null);
        dispatch(onGetArticleTrackings(query));
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdateLink((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }
  // End:: update memo


  // Begin:: update keyword news
  const [itemUpdateKeyword, setItemUpdateKeyword] = useState<{ id: number, keyword: string } | null>(null);
  const [isLoadingUpdateKeyword, setIsLoadingUpdateKeyword] = useState<boolean>(false);

  const handleUpdateKeyword = async () => {
    try {
      if (!itemUpdateKeyword) {
        return;
      }
      setIsLoadingUpdateKeyword((_prev) => true);
      const response: any = await putKeywordNews(itemUpdateKeyword?.id, { keyword: itemUpdateKeyword?.keyword });
      setIsLoadingUpdateKeyword((_prev) => false);
      if (response?.code === 200) {
        setQuery((_prev: any) => ({ ..._prev, time_request: + new Date() }));
        setItemUpdateKeyword((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdateKeyword((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }
  // End:: update keyword news


  // Begin:: update tags news
  const [itemUpdateTags, setItemUpdateTags] = useState<{ id: number, tags: { id: string, text: string }[] } | null>(null);
  const [isLoadingUpdateTags, setIsLoadingUpdateTags] = useState<boolean>(false);

  const handleUpdateTags = async () => {
    try {
      if (!itemUpdateTags) {
        return;
      }
      setIsLoadingUpdateTags((_prev) => true);
      const _tags: string[] = (itemUpdateTags?.tags || [])?.map((_tag: any) => `${_tag?.text || ''}`);
      const response: any = await putTagNews(itemUpdateTags?.id, { tags: _tags });
      setIsLoadingUpdateTags((_prev) => false);
      if (response?.code === 200) {
        setQuery((_prev: any) => ({ ..._prev, time_request: + new Date() }));
        setItemUpdateTags((_prev) => null);
        handleReloadTag();
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdateTags((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }
  // End:: update tags news

  // Begin:: update category news
  const [itemChangeCategory, setItemChangeCategory] = useState<{ id: number, categories: any[] } | null>(null);
  const [isLoadingChangeCategory, setIsLoadingChangeCategory] = useState<boolean>(false);

  const handleSubmitChangeCategory = async (values: any) => {
    try {
      if (!itemChangeCategory) {
        return;
      }
      setIsLoadingChangeCategory((_prev) => true);
      const categories_current = (values?.categories || [])?.filter((_c: any) => (!!_c?.value))?.map((_c: any) => ({
        id: Number(_c?.value),
        name: _c?.label || '',
      }));
      const categories_new = (values?.new_categories || [])?.filter((_c: any) => (!!_c?.id))?.map((_c: any) => ({
        id: null,
        name: _c?.id || '',
      }));
      const response: any = await putCategoryNews(itemChangeCategory?.id, {
        categories: [...categories_current, ...categories_new]
      });
      setIsLoadingChangeCategory((_prev) => false);
      if (response?.code === 200) {
        setQuery((_prev: any) => ({ ..._prev, time_request: + new Date() }));
        setItemChangeCategory((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        if (!!categories_new?.length) {
          handleReloadCategory();
        }
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingChangeCategory((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }


  const validationSchemaChangeCategory = Yup.object({
    categories: Yup.array().of(Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable()).nullable(),
    new_categories: Yup.array().of(
      Yup.object().shape({
        id: Yup.string(),
        text: Yup.string(),
      })
    ).nullable(),
  });

  const CATEGORY_DEFAULT = {
    value: '',
    label: ''
  };

  const NEW_CATEGORY_DEFAULT = '';

  const formikChangeCategory = useFormik({
    initialValues: {
      // category_name: '',
      // category_id: null,
      is_create_new_category: false,
      categories: [CATEGORY_DEFAULT],
      new_categories: []
    },
    validationSchema: validationSchemaChangeCategory,
    onSubmit: handleSubmitChangeCategory,
  });

  const handleAddCategory = (index: number) => {
    const timeArray = [...(formikChangeCategory.values.categories || []), (formikChangeCategory.values.categories || [])[(formikChangeCategory.values.categories || [])?.length - 1] || CATEGORY_DEFAULT];
    formikChangeCategory.setFieldValue("categories", timeArray);
  };

  const handleRemoveCategory = (index: number) => {
    const timeArray = (formikChangeCategory.values.categories || [])?.filter((_m, ind: number) => ind !== index);
    formikChangeCategory.setFieldValue("categories", timeArray?.length === 0 ? [CATEGORY_DEFAULT] : timeArray);
  };

  const handleAddNewCategory = (index: number) => {
    const timeArray = [...(formikChangeCategory.values.new_categories || []), NEW_CATEGORY_DEFAULT];
    formikChangeCategory.setFieldValue("new_categories", timeArray);
  };

  const handleRemoveNewCategory = (index: number) => {
    const timeArray = (formikChangeCategory.values.new_categories || [])?.filter((_m, ind: number) => ind !== index);
    formikChangeCategory.setFieldValue("new_categories", timeArray?.length === 0 ? [NEW_CATEGORY_DEFAULT] : timeArray);
  };

  const handleOpenModalChangeCategory = (item: { id: number, categories: any[] }) => {
    setItemChangeCategory((_prev) => item);
    // const _info_categories = item?.categories?.length ? (item?.categories)?.map((_c: any) => {
    //   return ({ label: '', value: String(_c?.id) });
    // }) : [CATEGORY_DEFAULT];

    const _info_categories = item?.categories?.length ? (item?.categories)?.map((_c: any) => {
      return boostingCategories?.find((_o: any) => String(_o?.value) === String(_c?.id));
    }) : [CATEGORY_DEFAULT];

    setTimeout(() => {
      formikChangeCategory.setFieldValue(`categories`, _info_categories);
      formikChangeCategory.setFieldValue(`new_categories`, []);
      // formikChangeCategory?.setFieldValue('category_id', { label: '', value: `${item?.category_id || ''}` });
      formikChangeCategory?.setFieldValue('is_create_new_category', 0);
      // formikChangeCategory?.setFieldValue('category_name', '');
    }, 300);
  }
  // End:: update category news


  // Begin::Open Chart Ranking
  const [isChartLoading, setIsChartLoading] = useState<boolean>(false);

  const [dateRangeChartSearch, setDateRangeChartSearch] = useState<any[]>([moment().toDate(), moment().toDate()]);
  const [startDateChart, endDateChart] = dateRangeChartSearch;

  const handleGetDataChart = async (_chart: any) => {
    try {
      setIsChartLoading((_prev) => true);
      const _data_form = {
        news_id: _chart?.news_id,
        date_start: _chart?.date_start ? _chart?.date_start : (startDateChart ? moment(new Date(startDateChart)).format("Y-MM-DD") : ''),
        date_end: _chart?.date_end ? _chart?.date_end : (endDateChart ? moment(new Date(endDateChart)).format("Y-MM-DD") : ''),
      };
      const response: any = (_chart?.type === 'DAILY_SEARCH_VOLUME_TREND') ? await getChartDailySearchVolumeRankingKeywordNews(_data_form) : await getChartRankingKeywordNews(_data_form);
      setIsChartLoading((_prev) => false);
      if (response?.code === 200) {
        const _data_chart = response?.data?.map((c: any) => ({ date: c?.col, index: Number(c?.[`${_chart?.key_data}`] || 0) }));
        setChart((_prev: any) => ({ ..._prev, data: _data_chart }));
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsChartLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleSearchDataChart = async () => {
    handleGetDataChart(chart);
  };

  const handleOpenModelChart = async (_chart: any) => {
    const _date_start = _chart?.type === 'DAILY_SEARCH_VOLUME_TREND' ? moment().subtract(7, 'days').toDate() : moment().toDate();
    const _date_end = moment().toDate();
    setDateRangeChartSearch((_prev) => ([_date_start, _date_end]));
    setIsOpenChart((_prev) => true);
    setChart((_prev: any) => _chart);
    handleGetDataChart({ ..._chart, date_start: moment(_date_start).format("Y-MM-DD"), date_end: moment(_date_end).format("Y-MM-DD") });
  };

  const handleCloseChart = () => {
    setIsOpenChart((_prev) => false);
    setDateRangeChartSearch((_prev) => ([moment().toDate(), moment().toDate()]));
  };
  // End::Open Chart Ranking


  // Begin::Delete
  const handleConfirmDelete = (item: any) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!initialValuesDefault?.news_id && !countRowSelected) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const ids = initialValuesDefault?.news_id ? [initialValuesDefault?.news_id] : (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await deleteNewsMulti({
        ids: ids
      });
      if (response?.code === 200) {
        setQuery((_prev: any) => ({ ..._prev, time_request: + new Date() }));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete

  const handleDownloadExcel = async () => {
    try {
      setIsLoadingExportFile((_prev) => true);
      const response: any = await downloadExcelTrackingNews({ ...query });
      if (response?.data) {
        setIsLoadingExportFile((_prev) => false);
        const link = document.createElement('a');
        link.href = response?.data?.url;
        link.download = 'tracking_news';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setIsLoadingExportFile((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingExportFile((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const [optionsSelected, setOptionsSelected] = useState<any>([]);

  // Begin:: handle select table 
  const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
    // if (!!isFirstLoadingPageRef.current) {
    //   return;
    // }
    const index = String(valueIndex);
    if (valueCheck?.value === 'ALL') {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (e.target.checked) {
          if (prevClone[index] === undefined) {
            prevClone[index] = [];
          }
          if (prevClone[index]?.length > 0) {
            prevClone[index] = [];
            return prevClone;
          }
          prevClone[index] = (articleTrackings?.list || [])?.reduce((arr: any, item: any) => (String(item?.news_type) === String(NEWS_TYPE.EXTERNAL_NEWS) ? ([...arr, ({ value: item?.news_id, label: item?.news_id })]) : arr), []);
          return prevClone;
        } else {
          prevClone[index] = [];
          return prevClone;
        }
      });
      return;
    }
    if (!e.target.checked) {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
        return prevClone;
      });
    } else {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = ([...prevClone[index], valueCheck]);
        return prevClone;
      });
    }
  };

  const isChecked = (valueCheck: Option) => {
    const index = String(query.page);
    return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
  };

  const isCheckedAll = (valueIndex: string) => {
    const valueIndexString = String(valueIndex);
    return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === articleTrackings?.list?.length);
  };

  const countRowSelected = useMemo(() => {
    return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
      return Number(total + (value || [])?.length);
    }, 0)
  }, [optionsSelected]);

  // End:: handle select table 

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "news_id",
        filterable: true,
        sortable: true,
        thWidth: 100,
        thClass: "align-middle text-center",
        Cell: (cell: any) => (
          <>
            <div className="text-center" style={{ minWidth: '80px' }}>
              <CopyWrapper contentCopy={cell?.value}>
                {cell?.value}
              </CopyWrapper>
            </div>
          </>
        ),
      },
      {
        Header: t('Media'),
        accessor: "partner_id",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: 'align-middle text-start',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const _partner = partners?.find((_p: any) => String(_p?.id) === String(item?.partner_id));
          return (<>
            <div style={{ minWidth: '120px' }} className="text-start">
              {item?.text_row ? item?.text_row : (_partner?.name || '-')}
            </div>
          </>)
        },
      },
      {
        Header: t('Category'),
        accessor: "section",
        filterable: true,
        sortable: false,
        thClass: 'align-middle text-start',
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div className="d-flex justify-content-between align-items-center">
            {/* <div style={{ width: '100px' }} >
              {item?.keyword_category?.name || (SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(item?.section))?.label || '-')}
            </div> */}
            <div style={{ minWidth: '130px' }} className="d-flex flex-column align-items-start gap-2">
              {item?.categories ? (item?.categories || [])?.map((_c: any) => (
                <span className="rounded-pill badge bg-primary-subtle text-primary fs-13" key={_c?.id}>{_c?.name}</span>
              )) : (SECTION_KEYWORD_OPTIONS_LANG?.find((s) => String(s?.value) === String(item?.section))?.label || '-')}
            </div>
            <div>
              {!item?.text_row && <button className="btn btn-sm edit-item-btn text-primary"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleOpenModalChangeCategory({ id: item?.news_id, categories: item?.categories || '', }); }}
              >
                <i className="ri-pencil-fill align-bottom"></i>
              </button>}
            </div>
          </div>)
        },
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: 'align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div className="d-flex justify-content-between align-items-center">
            <div style={{ width: '100px' }} className="fs-15">
              {cell?.value ? <Link
                className="nav-link hover-underline"
                target="_blank"
                to={`https://search.naver.com/search.naver?ssc=tab.news.all&where=news&sm=tab_jum&query=${cell?.value || ''}`}>
                {cell?.value || '-'}
              </Link> : '-'}
            </div>
            <div>
              {!!cell?.value && <button className="btn btn-sm edit-item-btn text-primary"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); setItemUpdateKeyword(() => ({ id: item?.news_id, keyword: item?.keyword })) }}
              >
                <i className="ri-pencil-fill align-bottom"></i>
              </button>}
            </div>
          </div>)
        },
      },
      {
        Header: t('Article Title'),
        accessor: "title",
        filterable: true,
        sortable: false,
        thClass: 'align-middle',
        thWidth: (window.innerWidth < 1650 ? 300 : 600),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <CopyWrapper contentCopy={item?.partner_news_url || ''} isShow={true} style={{ display: 'inline-flex', minWidth: '300px' }}>
              <div style={{ minWidth: '250px', maxWidth: '600px' }} className="fs-15">
                {String(item?.partner_news_expose_flg) === String(IMPRESSION_OPTIONS_LANG[1].value) && <div className="icon-x">X</div>}
                {String(item?.section) === String(SECTION_KEYWORD.EXTERNAL) && <div className="icon-m">M</div>}
                <Link
                  className="nav-link hover-underline d-inline-block"
                  target="_blank"
                  to={item?.partner_news_url || ''}
                  onClick={(e: any) => {
                    if (!item?.partner_news_url) {
                      e.stopPropagation();
                      e.preventDefault();
                      toast(t('The article has not been registered in the media CMS yet. Please try again later!'), CONFIG_OPTION_TOAST_ERROR);
                      return;
                    }
                  }}
                >
                  <HighlightText text={item?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} />
                </Link>
              </div>
            </CopyWrapper>
          </>)
        },
      },
      {
        Header: t('Impression'),
        accessor: "impression_count",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 120 : 100,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (!!item?.text_row ? <div className="text-end pe-3 " style={{ minWidth: i18n?.language === 'en' ? '100px' : '80px' }}>
            {formatNumberWithCommas(cell?.value || 0)}
          </div> :
            <div className="text-end pe-3  hover-underline cursor-pointer " style={{ minWidth: i18n?.language === 'en' ? '100px' : '80px' }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModelChart({ type: 'IMPRESSION_TREND', title: t('Impression Trend'), keyword: t('Impression'), data: [], news_id: item?.news_id, key_data: 'impression_count' });
              }}
            >{formatNumberWithCommas(cell?.value || 0)}</div>
          )
        },
      },
      {
        Header: t('Click'),
        accessor: "click_count",
        filterable: true,
        sortable: true,
        thWidth: 100,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (!!item?.text_row ? <div className="text-end pe-3" style={{ minWidth: '80px' }} >
            {formatNumberWithCommas(cell?.value || 0)}
          </div> :
            <div className="text-end pe-3  hover-underline cursor-pointer " style={{ minWidth: '80px' }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModelChart({ type: 'CLICK_TREND', title: t('Click Trend'), keyword: t('Click'), data: [], news_id: item?.news_id, key_data: 'click_count' });
              }}
            >{formatNumberWithCommas(cell?.value || 0)}</div>
          )
        },
      },
      {
        Header: t('CTR'),
        accessor: "ctr_count",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        thWidth: i18n?.language === 'en' ? 120 : 110,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (!!item?.text_row ? <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '100px' : '90px' }} >
            {formatNumberWithCommas(cell?.value)} %
          </div> :
            <div className="text-end pe-3  hover-underline cursor-pointer " style={{ minWidth: i18n?.language === 'en' ? '100px' : '90px' }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModelChart({ type: 'CTR_TREND', title: t('CTR Trend'), keyword: t('CTR'), data: [], news_id: item?.news_id, key_data: 'ctr_count' });
              }}
            >{formatNumberWithCommas(cell?.value)} %</div>
          )
        },
      },
      {
        Header: t('Impression Rate'),
        accessor: "impression_rate_count",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 170 : 120,
        thClass: 'align-middle text-end',
        description: t('The impression rate is the percentage of exposure compared to the daily search volume.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (!!item?.text_row ? <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '150px' : '100px' }} >
            {formatNumberWithCommas(cell?.value)} %
          </div> :
            <div className="text-end pe-info  hover-underline cursor-pointer " style={{ minWidth: i18n?.language === 'en' ? '150px' : '100px' }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModelChart({ type: 'IMPRESSION_RATE_TREND', title: t('Impression Rate Trend'), keyword: t('Impression Rate'), data: [], news_id: item?.news_id, key_data: 'impression_rate' });
              }}
            >{formatNumberWithCommas(cell?.value)} %</div>
          )
        },
      },
      {
        Header: t('Daily Search Volume'),
        accessor: "daily_search_volume",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 190 : 140,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (!!item?.text_row ? <div className="text-end pe-3 " style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}>
            -
          </div> :
            <div className="text-end pe-3  hover-underline cursor-pointer " style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenModelChart({ type: 'DAILY_SEARCH_VOLUME_TREND', title: t('Daily Search Volume Trend'), keyword: t('Daily Search Volume'), data: [], news_id: item?.news_id, key_data: 'daily_search_volume' });
              }}
            >{formatNumberWithCommas(cell?.value || 0)}</div>
          )
        },
      },
      {
        Header: t('Article Ranking'),
        accessor: "exposure_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('This is the ranking of the article in Naver News search results (as of today).'),
        thWidth: i18n?.language === 'en' ? 160 : 130,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            !!item?.text_row ? <div className="text-end pe-info">-</div> :
              <div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info  hover-underline cursor-pointer "
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleOpenModelChart({ type: 'RANK_TREND', title: t('Rank Trend'), keyword: t('Rank'), data: [], news_id: item?.news_id, key_data: 'exposure_rank' });
                }}
              >
                {
                  (cell?.value !== null && cell?.value !== undefined) ? <>
                    {formatNumberWithCommas(cell?.value || 0)}
                  </> : '-'
                }
              </div>)
        },
      },
      {
        Header: t('PA Media Ranking'),
        accessor: "affiliate_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of Press AI-affiliated media in Naver News search results. (Based on today’s data.)'),
        thWidth: i18n?.language === 'en' ? 180 : 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info">
            {
              (cell?.value !== null && cell?.value !== undefined) ? <>
                {formatNumberWithCommas(cell?.value || 0)}
              </> : '-'
            }
          </div>)
        },
      },
      {
        Header: t('S.M Ranking'),
        accessor: "search_media_rank",
        filterable: true,
        sortable: true,
        thWidth: 160,
        thClass: 'align-middle text-end',
        description: t('The ranking of all Naver search-affiliated media in Naver News search results. (Based on today’s data.)'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '120px' }}>{(cell?.value === null || item?.text_row) ? '-' : formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('News Section'),
        accessor: "news_section_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of the news section in Naver search results (as of today).'),
        thWidth: i18n?.language === 'en' ? 150 : 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '120px' }} className="text-end pe-info">
            {item?.news_section_rank ?? '-'}
          </div>)
        },
      },
      {
        Header: t('Survival Period'),
        accessor: "survival_at",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 160 : 110,
        thClass: 'align-middle text-end',
        description: t('The duration for which the article remains within the top 4 rankings (as of today).'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '140px' : '90px' }}>
              {item?.survival_at ? <TooltipCustom
                title={item?.survival_at || ''}
                className="d-inline-block vertical-align-middle ms-1"
                style={{ transform: 'translateY(1px)' }}
              >
                <span>{item?.survival_at_label || ''}</span>
              </TooltipCustom> : <>-</>}
            </div>
          </>)
        },
      },
      {
        Header: t('PA Index'),
        accessor: "pa_index",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        description: t('Press Ai keyword index. (Updated hourly)'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '100px' }}>{(cell?.value === null || item?.text_row) ? '-' : formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('Published At'),
        accessor: "publish_at",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 140 : 100,
        thClass: 'align-middle text-end',
        description: t('The date the article was published to the media via Press AI.'),
        thComponent: () => (
          <span onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChangeSorting({
              sort_by: "publish_at",
              order_by: query?.order_by === "DESC" && query?.sort_by === "publish_at" ? "ASC" : "DESC",
            });
          }}>
            {t("Published At")}
            {query?.sort_by === "publish_at" && (
              <span
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  width: "12px",
                  marginLeft: "2px",
                  verticalAlign: "middle",
                }}
              >
                {query?.order_by === "DESC" ? (
                  <i className={`ri-arrow-up-line fs-13 text-primary`} />
                ) : (
                  <i
                    className={`ri-arrow-down-line fs-13 text-primary`}
                  />
                )}
              </span>
            )}
          </span>
        ),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '120px' : '80px' }}>
              <TooltipCustom
                title={item?.publish_at || ''}
                className="d-inline-block vertical-align-middle ms-1"
                style={{ transform: 'translateY(1px)' }}
              >
                <span>{item?.publish_at_label || '-'}</span>
              </TooltipCustom>
            </div>
          )
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 140 : 100,
        thClass: 'align-middle text-end',
        description: t('The date the article was created in Boosting News.'),
        thComponent: () => (
          <span onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChangeSorting({
              sort_by: "created_at",
              order_by: query?.order_by === "DESC" && query?.sort_by === "created_at" ? "ASC" : "DESC",
            });
          }}>
            {t("Created At")}
            {query?.sort_by === "created_at" && (
              <span
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  width: "12px",
                  marginLeft: "2px",
                  verticalAlign: "middle",
                }}
              >
                {query?.order_by === "DESC" ? (
                  <i className={`ri-arrow-up-line fs-13 text-primary`} />
                ) : (
                  <i
                    className={`ri-arrow-down-line fs-13 text-primary`}
                  />
                )}
              </span>
            )}
          </span>
        ),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '120px' : '80px' }}>
              <TooltipCustom
                title={item?.created_at || ''}
                className="d-inline-block vertical-align-middle ms-1"
                style={{ transform: 'translateY(1px)' }}
              >
                <span>{item?.created_at_label || '-'}</span>
              </TooltipCustom>
            </div>
          )
        },
      },
      {
        Header: t('Article Date'),
        accessor: "partner_news_rank_time",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 140 : 110,
        thClass: 'align-middle text-end',
        description: t('The date the article was first registered in Naver News search results.'),
        thComponent: () => (
          <span onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChangeSorting({
              sort_by: "partner_news_rank_time",
              order_by: query?.order_by === "DESC" && query?.sort_by === "partner_news_rank_time" ? "ASC" : "DESC",
            });
          }}>
            {t("Article Date")}
            {query?.sort_by === "partner_news_rank_time" && (
              <span
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  width: "12px",
                  marginLeft: "2px",
                  verticalAlign: "middle",
                }}
              >
                {query?.order_by === "DESC" ? (
                  <i className={`ri-arrow-up-line fs-13 text-primary`} />
                ) : (
                  <i
                    className={`ri-arrow-down-line fs-13 text-primary`}
                  />
                )}
              </span>
            )}
          </span>
        ),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '120px' : '90px' }}>
              {item?.partner_news_rank_time ? <TooltipCustom
                title={item?.partner_news_rank_time || ''}
                className="d-inline-block vertical-align-middle ms-1"
                style={{ transform: 'translateY(1px)' }}
              >
                <span>{item?.partner_news_rank_time_label || ''}</span>
              </TooltipCustom> : <>-</>}
            </div>
          )
        },
      },
      {
        Header: t('Registrar'),
        accessor: "admin",
        filterable: true,
        sortable: false,
        thWidth: 190,
        thClass: 'align-middle text-end',
        description: t('The name of the user who published the news'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '160px' }} className="fs-15 text-end">
              {!!item?.admin ? <>{item?.admin?.username || '-'} <br />
                <span className="fs-13 text-muted">{item?.admin?.email || '-'}</span>
              </> : <span className="fs-13">-</span>}
            </div>
          </>)
        },
      },
      {
        Header: t('Tags'),
        accessor: "tags",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: 'align-middle text-end pe-3',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const _tags = (item?.tags || [])?.map((_tag: string) => ({ id: _tag, text: _tag }));
          return (!!item?.text_row ? <div className="d-flex justify-content-end align-items-center pe-2">-</div> :
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ width: '110px' }} className="d-flex justify-content-end flex-wrap align-items-center gap-1 fs-16">
                {(item?.text_row || !(item?.tags || [])?.length) ? <>-</> : <>{(item?.tags || [])?.map((_tags: string) => (
                  <span key={_tags} className="badge bg-primary-subtle text-primary">
                    {_tags || ''}
                  </span>
                ))}</>}
              </div>
              <div>
                {!!cell?.value && <button className="btn btn-sm edit-item-btn text-primary"
                  onClick={(e) => { e.stopPropagation(); e.preventDefault(); setItemUpdateTags(() => ({ id: item?.news_id, tags: _tags })) }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </button>}
              </div>
            </div>)
        },
      },
      {
        Header: t('Type'),
        accessor: "news_type",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 120 : 90,
        thClass: 'align-middle text-center',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-center" style={{ minWidth: i18n?.language === 'en' ? '100px' : '70px' }}>
              {TYPE_NEWS_OPTIONS_LANG?.find((_t) => String(_t?.value) === String(item?.news_type))?.label || '-'}
            </div>
          </>)
        },
      },
      {
        Header: t('Media Section'),
        accessor: "partner_code_id",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const _partner = partners?.find((_p: any) => String(_p?.id) === String(item?.partner_id));
          const _partner_code = _partner?.partner_codes?.find((_s: any) => String(_s?.id) === String(item?.partner_code_id))
          return (
            <div style={{ minWidth: '120px' }} className="text-center">
              {_partner_code?.section_title || '-'}
            </div>
          );
        }
      },
      {
        Header: t('Date'),
        accessor: "date",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '80px' }}>
              <span><span>{arrDate?.[0] || ''}</span></span>
            </div>
          )
        },
      },
      {
        Header: t('Actions'),
        accessor: "__",
        thClass: 'align-middle text-center',
        thWidth: 80,
        sortable: false,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '60px' }}>
              {(isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) && String(item?.section) === String(SECTION_KEYWORD.EXTERNAL)) && (
                <TooltipCustom
                  title={t('Button Delete News')}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleConfirmDelete(item) }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },

    ],
    [i18n?.language, JSON.stringify(partners), query?.order_by, query?.sort_by] // JSON.stringify(optionsSelected)
  );

  const triggerRefresh = (_option: { is_refresh_category: boolean, is_refresh_tags: boolean } = { is_refresh_category: false, is_refresh_tags: false }) => {
    setIsOpenImportMediaNews((_prev) => false);
    setIsOpenImportNews((_prev) => false);
    dispatch(onGetArticleTrackings(query));
    onGetSummariesArticleTrackings(query);
    if (!!_option?.is_refresh_category) {
      handleReloadCategory();
    }
    if (!!_option?.is_refresh_tags) {
      handleReloadTag();
    }

  };

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy, page: 1 });
    });
  }, []);


  const handleReloadCategory = async () => {
    const [res1]: any = await Promise.all([getAllCategory()]);
    const _boostingCategories = (res1?.data)?.map((_c: any) => ({ label: _c?.name, value: `${_c?.id}` }));
    setBoostingCategories((_prev: any) => _boostingCategories);
  };

  const handleReloadTag = async () => {
    const [res1]: any = await Promise.all([getAllTagNews({})]);
    const _tags = (res1?.data)?.map((_t: any) => ({ label: _t?.name, value: `${_t?.id}` }));
    setTags((_prev: any) => _tags);
  };

  const handleCallAllOption = async () => {
    try {
      const [res1, res2, res3, res4]: any = await Promise.all([getAllCategory(), getAllPartners({}), getAllOperators(), getAllTagNews({})]);
      const _boostingCategories = (res1?.data)?.map((_c: any) => ({ label: _c?.name, value: `${_c?.id}` }));
      const _tags = (res4?.data || [])?.map((_t: any) => ({ label: _t?.name, value: `${_t?.id}` }));
      setBoostingCategories((_prev: any) => _boostingCategories);
      setPartners((_prev: any) => res2?.data);
      setOperators((_prev: any) => res3?.data);
      setTags((_prev: any) => _tags);
      if (query?.partner_id) {
        const _partner = res2?.data?.find((_p: any) => String(_p?.id) === String(query?.partner_id));
        setMediaSearch({ value: `${_partner?.id}`, label: _partner?.name });
      }
      if (query?.partner_code_id) {
        const _partner = res2?.data?.find((_p: any) => String(_p?.id) === String(query?.partner_id));
        const _partner_code = _partner?.partner_codes?.find((_s: any) => String(_s?.id) === String(query?.partner_code_id));
        setMediaSectionSearch({ value: `${_partner_code?.id}`, label: _partner_code?.section_title });
      }
      if (query?.category_id) {
        const _category = (_boostingCategories)?.find((s: any) => String(s?.value) === String(query?.category_id));
        setSectionSearch(_category);
      }
      if (query?.section) {
        const _section: any = (SECTION_KEYWORD_OPTIONS_LANG)?.find((s) => String(s?.value) === String(query?.section));
        setSectionSearch(_section);
      }
      if (query?.admin_id) {
        const _operator = res3?.data?.find((_p: any) => String(_p?.id) === String(query?.admin_id));
        setAdminSearch({ value: `${_operator?.id}`, label: _operator?.username });
      }
      if (query?.tag_ids) {
        const _tag_ids = _tags?.filter((_p: any) => (String(query?.tag_ids)?.split(','))?.includes(String(_p?.value)));
        setTagsSearch(_tag_ids);
      }
    } catch (error: any) {
      return error;
    }
  };

  const handleChangeDateRangePicker = (values: any[] = []) => {
    setDateRangeSearch((_prev: any) => values);
  }

  const handleChangeDatePublishedRangePicker = (values: any[] = []) => {
    setDatePublishedRangeSearch((_prev: any) => values);
  }

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // useEffect(() => {
  //   if (!mediaSearch?.value) {
  //     setMediaSearch({ label: t('All'), value: '' });
  //   }
  //   if (!mediaSectionSearch?.value) {
  //     setMediaSectionSearch({ label: t('All'), value: '' });
  //   }
  //   if (!sectionSearch?.value) {
  //     setSectionSearch({ label: t('All'), value: '' });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [i18n?.language]);


  useEffect(() => {
    if (!!isPage) {
      document.title = `${t('News Monitor')} | ${t('PRESS Ai')}`;
      document.body.classList.remove('vertical-sidebar-enable');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className={!!isPage ? "page-content" : ""}>
        <Container fluid className={isPage ? '' : 'p-0'}>
          {!!isPage && <BreadCrumb title={t('News Monitor')} pageTitle={t('Home')} />}
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className={`ribbon-box right ${isPage ? '' : 'border-0'}`}>
                  <div className="ribbon round-shape top-info-md" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem', }}>{t('This data is analyzed per 10 mins')}</div>
                  <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                    <Row className="g-4 align-items-center justify-content-xxl-between ">
                      <div className="col-12 col-md-12 col-xl-12  col-xxl-auto mt-5 mt-md-4">
                        <div>
                          <h5 className="card-title mb-0 d-flex gap-1 gap-xxl-2 flex-wrap">
                            <div>
                              <span className="me-2">{t('Total')}:</span>
                              {(isArticleTrackingLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={articleTrackings?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </div>
                            <span className="text-muted">|</span>
                            <div>
                              <span className="me-2">{t('Approved Articles')}<TooltipCustom
                                title={t("Updated hourly")}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(1px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>:</span>
                              {(isArticleTrackingLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={summaries?.approved_article_count || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </div>
                            <span className="text-muted">|</span>
                            <div>
                              <span className="me-2">{t('Naver Articles')}<TooltipCustom
                                title={t("This is the number of articles that have appeared at least once on the first page of Naver News search results.")}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(1px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>:</span>
                              {(isArticleTrackingLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={summaries?.naver_article_count || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </div>
                            <span className="text-muted">|</span>
                            <div>
                              <span className="me-2">{t('Clicks per Article')}<TooltipCustom
                                title={t("The number of clicks per approved article on the specified distribution date. Clicks per Article = Total Clicks / Total Approved Articles")}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(1px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>:</span>
                              {(isArticleTrackingLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={summaries?.click_per_article || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </div>
                          </h5>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-xl-12 col-xxl-auto flex-grow-1 text-end mt-3 mt-md-4">
                        <div className={`d-flex gap-2 gap-sm-3 flex-wrap justify-content-end padding-xxl-right-info-${i18n?.language}`}>
                          {isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={() => setIsOpenImportNews((_prev) => true)}
                          >
                            <i className="ri-add-line align-bottom"></i>
                            <span className="ms-1">{t('Button Import Article')}</span>
                          </button>)}
                          {isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={() => setIsOpenImportMediaNews((_prev) => true)}
                          >
                            <i className="ri-upload-line align-bottom"></i>
                            <span className="ms-1">{t('Button Import Bulk Articles')}</span>
                          </button>)}
                          {isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={handleDownloadExcel}
                            disabled={isLoadingExportFile}
                          >
                            {isLoadingExportFile ? <Spinner size="sm" ></Spinner> : <i className="ri-download-line align-bottom"></i>}
                            <span className="ms-1">{t('Button Download Excel')}</span>
                          </button>)}
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-end mt-0">
                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Media')} isShow={true}>
                            <DropdownOption
                              name="media"
                              dataList={filterMediaOptions(partners || [])?.map((_p: any) => ({ label: _p?.name, value: `${_p?.id}` }))}
                              placeholder={`${t("Media")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={mediaSearch || null}
                              onChangeSelect={(e: any) => setMediaSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Media Section')} isShow={true}>
                            <DropdownOption
                              name="media_section"
                              dataList={(filterMediaOptions(partners || [])?.find((_p: any) => String(_p?.id) === String(mediaSearch?.value))?.partner_codes || [])?.map((_s: any) => ({ label: _s?.section_title, value: `${_s?.id}` }))}
                              placeholder={`${t("Media Section")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={mediaSectionSearch || null}
                              onChangeSelect={(e: any) => setMediaSectionSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Type')} isShow={true}>
                            <DropdownOption
                              name="type_news"
                              dataList={TYPE_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("Type")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeNewsSearch || null}
                              onChangeSelect={(e: any) => setTypeNewsSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t("Category")} isShow={true}>
                            <DropdownOption
                              name="category_or_section"
                              dataList={(typeNewsSearch?.value === '1') ? SECTION_KEYWORD_OPTIONS_LANG : (typeNewsSearch?.value === '2' ? boostingCategories : [])}
                              placeholder={`${t("Category")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={sectionSearch || null}
                              onChangeSelect={(e: any) => setSectionSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Published At')} isShow={!!startDatePublished || !!endDatePublished}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDatePublished || null}
                              endDate={endDatePublished || null}
                              onChangePicker={handleChangeDatePublishedRangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={4} xxl={2} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangeDateRangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startPAIndexSearch}
                            valueTo={endPAIndexSearch}
                            placeholderFrom={`${t('PA Index (Start)')}...`}
                            placeholderTo={`${t('PA Index (End)')}...`}
                            labelFrom={`${t('PA Index (Start)')}`}
                            labelTo={`${t('PA Index (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartPAIndexSearch(val)}
                            onChangeTo={(val) => setEndPAIndexSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startExposureSearch}
                            valueTo={endExposureSearch}
                            placeholderFrom={`${t('Article Ranking (Start)')}...`}
                            placeholderTo={`${t('Article Ranking (End)')}...`}
                            labelFrom={`${t('Article Ranking (Start)')}`}
                            labelTo={`${t('Article Ranking (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartExposureSearch(val)}
                            onChangeTo={(val) => setEndExposureSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startPAMediaRankSearch}
                            valueTo={endPAMediaRankSearch}
                            placeholderFrom={`${t('PA Media Ranking (Start)')}...`}
                            placeholderTo={`${t('PA Media Ranking (End)')}...`}
                            labelFrom={`${t('PA Media Ranking (Start)')}`}
                            labelTo={`${t('PA Media Ranking (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartPAMediaRankSearch(val)}
                            onChangeTo={(val) => setEndPAMediaRankSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startImpressionSearch}
                            valueTo={endImpressionSearch}
                            placeholderFrom={`${t('Impression (Start)')}...`}
                            placeholderTo={`${t('Impression (End)')}...`}
                            labelFrom={`${t('Impression (Start)')}`}
                            labelTo={`${t('Impression (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartImpressionSearch(val)}
                            onChangeTo={(val) => setEndImpressionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startClickSearch}
                            valueTo={endClickSearch}
                            placeholderFrom={`${t('Click (Start)')}...`}
                            placeholderTo={`${t('Click (End)')}...`}
                            labelFrom={`${t('Click (Start)')}`}
                            labelTo={`${t('Click (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartClickSearch(val)}
                            onChangeTo={(val) => setEndClickSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startCtrSearch}
                            valueTo={endCtrSearch}
                            placeholderFrom={`${t('CTR (Start)')}...`}
                            placeholderTo={`${t('CTR (End)')}...`}
                            labelFrom={`${t('CTR (Start)')}`}
                            labelTo={`${t('CTR (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartCtrSearch(val)}
                            onChangeTo={(val) => setEndCtrSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startDailyVolumeSearch}
                            valueTo={endDailyVolumeSearch}
                            placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                            placeholderTo={`${t('Daily Search Volume (End)')}...`}
                            labelFrom={`${t('Daily Search Volume (Start)')}`}
                            labelTo={`${t('Daily Search Volume (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartDailyVolumeSearch(val)}
                            onChangeTo={(val) => setEndDailyVolumeSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3'>
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startSurvivalDaySearch}
                            valueTo={endSurvivalDaySearch}
                            placeholderFrom={`${t('Survival Period (Start)')}...`}
                            placeholderTo={`${t('Survival Period (End)')}...`}
                            labelFrom={`${t('Survival Period (Start)')}`}
                            labelTo={`${t('Survival Period (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartSurvivalDaySearch(val)}
                            onChangeTo={(val) => setEndSurvivalDaySearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-2 order-xxl-0 mt-3 mt-xxl-3'>
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startNewsSectionSearch}
                            valueTo={endNewsSectionSearch}
                            placeholderFrom={`${t('News Section (Start)')}...`}
                            placeholderTo={`${t('News Section (End)')}...`}
                            labelFrom={`${t('News Section (Start)')}`}
                            labelTo={`${t('News Section (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartNewsSectionSearch(val)}
                            onChangeTo={(val) => setEndNewsSectionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-4 order-xxl-0 mt-3 mt-xxl-3' >
                          <LabelWrapper label={t('Registrar')} isShow={true}>
                            <DropdownOption
                              name="admin_id"
                              dataList={(operators || [])?.map((_o: any) => ({ label: _o?.username, value: `${_o?.id}` }))}
                              placeholder={`${t("Registrar")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={adminSearch || null}
                              onChangeSelect={(e: any) => setAdminSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={3} xl={3} xxl={2} className='order-3 order-xxl-0 mt-3 mt-xxl-3' >
                          <LabelWrapper label={t('S.M Ranking')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={SM_RANK_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("S.M Ranking")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={rankSearch || null}
                              onChangeSelect={(e: any) => setRankSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_RANK_NEWS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={3} xl={3} xxl={2} className='order-3 order-xxl-0 mt-3 mt-xxl-3' >
                          <LabelWrapper label={t('Approval')} isShow={true}>
                            <DropdownOption
                              name="impression"
                              dataList={IMPRESSION_OPTIONS_LANG || []}
                              placeholder={`${t("Approval")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={impressionSearch || null}
                              onChangeSelect={(e: any) => setImpressionSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-5 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='order-4  order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Tags')} isShow={!!tagsSearch?.length}>
                            <DropdownMultiOption
                              name="tag_ids"
                              dataList={tags}
                              placeholder={`${t("Tags")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={tagsSearch || []}
                              onChangeSelect={(e: any) => setTagsSearch(e)}
                              isHasOptionAll={false}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-4  order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('News Title')} isShow={!!titleSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('News Title')}...`}
                              value={titleSearch}
                              onChange={(e) => setTitleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='order-5 order-lg-4 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('URL')} isShow={!!urlSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('URL')}...`}
                              value={urlSearch}
                              onChange={(e) => setUrlSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className="order-5 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end mt-3 mt-xxl-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 me-lg-2"
                              onClick={searchData}
                              disabled={isArticleTrackingLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                    {(Number(countRowSelected) > 0) && <Col sm={12} className="mt-4">
                      {isHavePermissionRole(ROLES_FOR_APP.ARTICLE_TRACKING, userPermissions) &&
                        <button
                          type="button"
                          className="btn btn-soft-danger"
                          style={{ width: '85px' }}
                          disabled={countRowSelected <= 0}
                          onClick={(e) => { e.stopPropagation(); handleConfirmDelete(null) }}
                        >
                          {countRowSelected > 0 && (
                            <span
                              className="position-absolute topbar-badge badge rounded-pill bg-danger"
                              style={{ transform: "translate(0%, -70%)" }}
                            >
                              {formatNumberWithCommas(countRowSelected)}
                              <span className="visually-hidden">
                                total keywords selected
                              </span>
                            </span>
                          )}
                          {t('Button Delete')}
                        </button>
                      }
                    </Col >}
                  </div>
                  <CardBody className="pt-0 px-0">
                    <div className="mx-3 my-4 mt-3">
                      <TableTrackingNewsContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card"
                        tableClass="align-middle table-have-first-row-is-total sticky-table-tracking-news"
                        theadClass="table-light"
                        columns={columns}
                        // data={articleTrackings?.list?.length ? articleTrackings?.list : []}
                        data={articleTrackings?.list?.length ? (
                          [
                            {
                              ...summaries,
                              text_row: t('Sum')
                            },
                            ...articleTrackings?.list]
                        ) : []}
                        customPageSize={query.limit}
                        customPageIndex={query.page - 1}
                        totalRecords={articleTrackings?.pagination?.total}
                        customPageCount={Math.ceil(Number(articleTrackings?.pagination?.total) / Number(articleTrackings?.pagination?.limit))}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        isShowPaginationOnTop={true}
                        sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isArticleTrackingLoading}
                      // newsIdOpen={newsIdOpen}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <ToastContainer closeButton={false} newestOnTop={false} className="toast---------text" pauseOnFocusLoss autoClose={2000} limit={2} />

        <Modal
          isOpen={!!itemUpdateLink?.id}
          centered={true}
          size="md"
          toggle={() => setItemUpdateLink((_prev) => null)}
          keyboard={true}
        >
          <ModalHeader toggle={() => setItemUpdateLink((_prev) => null)}>
            {t('Button Update Link')}
          </ModalHeader>
          <ModalBody className="">
            <Col md={12} lg={12}>
              <div>
                <label className="form-label">
                  {t("Link")}
                  <span className="text-danger"> *</span>
                </label>
                <Input
                  type="textarea"
                  rows={2}
                  id="link"
                  name="link"
                  autocomplete={false}
                  value={itemUpdateLink?.link}
                  placeholder={`${t("Link")}...`}
                  onChange={(event: any) => {
                    setItemUpdateLink((prev: any) => ({ ...prev, link: event?.target?.value || '' }))
                  }}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                <button
                  className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                  color="light"
                  type="button"
                  disabled={isLoadingUpdateLink}
                  style={{ width: '100px' }}
                  onClick={() => setItemUpdateLink((_prev) => null)}
                >
                  {t("Button Close")}
                </button>
                <button
                  className="btn btn-primary rounded-pill fs-14"
                  color="success"
                  type="button"
                  disabled={isLoadingUpdateLink}
                  style={{ width: '150px' }}
                  onClick={() => handleUpdateLink()}
                >
                  {isLoadingUpdateLink ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) :
                    <> {t("Button Update")}</>}
                </button>
              </div>
            </Col>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!itemUpdateKeyword?.id}
          centered={true}
          size="md"
          toggle={() => setItemUpdateKeyword((_prev) => null)}
          keyboard={true}
        >
          <ModalHeader toggle={() => setItemUpdateKeyword((_prev) => null)}>
            {t('Button Update Keyword')}
          </ModalHeader>
          <ModalBody className="">
            <Col md={12} lg={12}>
              <div>
                <label className="form-label">
                  {t("Keyword")}
                  <span className="text-danger"> *</span>
                </label>
                <Input
                  type="text"
                  id="keyword"
                  name="keyword"
                  autocomplete={false}
                  value={itemUpdateKeyword?.keyword}
                  placeholder={`${t("Keyword")}...`}
                  onChange={(event: any) => {
                    setItemUpdateKeyword((prev: any) => ({ ...prev, keyword: event?.target?.value || '' }))
                  }}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                <button
                  className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                  color="light"
                  type="button"
                  disabled={isLoadingUpdateKeyword}
                  style={{ width: '100px' }}
                  onClick={() => setItemUpdateKeyword((_prev) => null)}
                >
                  {t("Button Close")}
                </button>
                <button
                  className="btn btn-primary rounded-pill fs-14"
                  color="success"
                  type="button"
                  disabled={isLoadingUpdateKeyword}
                  style={{ width: '150px' }}
                  onClick={() => handleUpdateKeyword()}
                >
                  {isLoadingUpdateKeyword ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) :
                    <> {t("Button Update")}</>}
                </button>
              </div>
            </Col>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!itemUpdateTags?.id}
          centered={true}
          size="md"
          toggle={() => setItemUpdateTags((_prev) => null)}
          keyboard={true}
        >
          <ModalHeader toggle={() => setItemUpdateTags((_prev) => null)}>
            {t('Button Update Tags')}
          </ModalHeader>
          <ModalBody className="">
            <Col md={12} lg={12}>
              <div>
                <div style={{ minHeight: '80px' }}>
                  <label className="form-label">
                    {t("Tags")}
                  </label>
                  <Hashtag
                    name="tags"
                    placeholder={`${t("Press Enter to add a new tag")}...`}
                    suggestions={[]}
                    initialValue={itemUpdateTags?.tags || []}
                    onChangeTag={(event: any) => {
                      setItemUpdateTags((prev: any) => ({ ...prev, tags: event }))
                    }}
                    idSelected="hashtags-CampaignFormMulti"
                    maxHashtags={2000}
                    maxHeight="150px"
                  />
                </div>
              </div>
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                <button
                  className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                  color="light"
                  type="button"
                  disabled={isLoadingUpdateTags}
                  style={{ width: '100px' }}
                  onClick={() => setItemUpdateTags((_prev) => null)}
                >
                  {t("Button Close")}
                </button>
                <button
                  className="btn btn-primary rounded-pill fs-14"
                  color="success"
                  type="button"
                  disabled={isLoadingUpdateTags}
                  style={{ width: '150px' }}
                  onClick={() => handleUpdateTags()}
                >
                  {isLoadingUpdateTags ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) :
                    <> {t("Button Update")}</>}
                </button>
              </div>
            </Col>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!itemChangeCategory?.id}
          centered={true}
          size="md"
          toggle={() => setItemChangeCategory((_prev) => null)}
          keyboard={true}
        >
          <ModalHeader toggle={() => setItemChangeCategory((_prev) => null)}>
            {t('Button Update Category')}
          </ModalHeader>
          <ModalBody className="">
            <form onSubmit={formikChangeCategory.handleSubmit}>
              <Col sm={12} md={12} lg={12} className='mt-3 mb-1'>
                <div>
                  <label className="form-label">
                    {t("Category")}
                  </label>
                  <DropdownMultiOption
                    name={`categories`}
                    dataList={boostingCategories}
                    placeholder={t('Category')}
                    className="search-filter-category-type dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formikChangeCategory?.values?.categories}
                    onChangeSelect={(e: any) => {
                      formikChangeCategory.setFieldValue(`categories`, e)
                    }}
                    isHasOptionAll={false}
                  />
                  {(formikChangeCategory.touched.categories as any) && (formikChangeCategory.errors.categories as any)?.value ? (
                    <div className="text-danger mt-2">{(formikChangeCategory.errors.categories as any)?.value || ''}</div>
                  ) : null}
                </div>
              </Col>
              <div className="position-relative mb-0 mt-4" style={{ border: `${!!formikChangeCategory?.values?.is_create_new_category ? 1 : 0}px dashed rgb(191, 193, 201)`, borderRadius: '4px', padding: '10px 0px' }}>
                <div className='position-absolute' style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>
                  <Col sm={12} md={12} lg={12} className='mt-0'>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" checked={!!formikChangeCategory?.values?.is_create_new_category} id={`is_create_new_category`}
                        onChange={(event: any) => {
                          formikChangeCategory.setFieldValue(`is_create_new_category`, !!event.target.checked);
                          formikChangeCategory.setFieldValue(`new_categories`, []);
                        }}
                      />
                      <label className="form-check-label" htmlFor={`is_create_new_category`}><span className="text-muted">{t('and')}</span> {t('Create New Category')} {!!formikChangeCategory?.values?.is_create_new_category && <span className="text-danger">*</span>}</label>
                    </div>
                  </Col>
                </div>
                {!!formikChangeCategory?.values?.is_create_new_category && <div className="mb-0">
                  <Col sm={12} md={12} lg={12} className='mt-2 px-3'>
                    <div>
                      <label className="form-label">
                        {t("New Category")}
                      </label>
                      <Input
                        type="text"
                        className="mb-2"
                        id="new_categories"
                        name="new_categories"
                        autocomplete={false}
                        value={((formikChangeCategory?.values?.new_categories || [])?.[0] as any)?.id || ''}
                        placeholder={`${t("Category Name")}...`}
                        onChange={(event: any) => {
                          formikChangeCategory.setFieldValue("new_categories", [{ id: event?.target?.value || '', text: event?.target?.value || '' }]);
                        }}
                      />
                      {(formikChangeCategory.touched.new_categories as any) && (formikChangeCategory.errors.new_categories as any)?.id ? (
                        <div className="text-danger mt-2">{(formikChangeCategory.errors.new_categories as any)?.id || ''}</div>
                      ) : null}
                    </div>
                  </Col>
                </div>}
              </div>
              <Col lg={12}>
                <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-4">
                  <button
                    className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                    color="light"
                    type="button"
                    disabled={isLoadingChangeCategory}
                    style={{ width: '100px' }}
                    onClick={() => setItemChangeCategory((_prev) => null)}
                  >
                    {t("Button Close")}
                  </button>
                  <button
                    className="btn btn-primary rounded-pill fs-14"
                    color="success"
                    disabled={isLoadingChangeCategory}
                    style={{ width: '150px' }}
                    type="submit"
                  >
                    {isLoadingChangeCategory ? (
                      <Spinner size="sm" className="me-2"></Spinner>
                    ) :
                      <> {t("Button Update")}</>}
                  </button>
                </div>
              </Col>
            </form>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isOpenChart}
          centered={true}
          size="xl"
          scrollable={false}
          toggle={() => handleCloseChart()}
        >
          <ModalHeader toggle={() => handleCloseChart()}>
            <>{chart?.title || ''}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <Row className="align-items-end">
              <Col sm={8} md={6} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                <LabelWrapper label={t('Date')} isShow={!!startDateChart || !!endDateChart}>
                  <DatePickerCustom
                    placeholder={`${t('Start Date')} - ${t('End Date')}`}
                    startDate={startDateChart || null}
                    endDate={endDateChart || null}
                    onChangePicker={(values: any) => {
                      setDateRangeChartSearch((_prev: any) => values);
                    }}
                    showOptions={[
                      'today', 'yesterday',
                      'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                      'this_week', 'last_week',
                      'this_month', 'last_month',
                    ]}
                  />
                </LabelWrapper>
              </Col>
              <Col sm={4} md={6}>
                <button
                  type="button"
                  className="btn btn-primary me-2 me-lg-2"
                  onClick={() => handleSearchDataChart()}
                  disabled={isArticleTrackingLoading}
                >
                  <i className="ri-search-line align-bottom me-1"></i>{" "}
                  {t('Button Search')}
                </button>
              </Col>
            </Row>
            <div style={{ minHeight: "170px" }} className="position-relative overflow-x-auto overflow-x-lg-hidden overflow-y-hidden">
              <RankingChart
                data={chart?.data}
                name={chart?.keyword || ''}
                height={window.innerWidth < 750 ? 250 : 350}
                style={{ transform: 'translateY(0px)', minWidth: window.innerWidth < 750 ? '900px' : 'auto' }}
                isShowXaxis={true}
                isShowYaxis={true}
                isShowTooltip={true}
                showAxisBorder={true}
                fillColor="#FDEBC7"
                fillOpacity={1}
                markersSize={3}
                isRotate={true}
                tickAmountXaxis={30}
                isPercentYaxis={['IMPRESSION_RATE_TREND', 'CTR_TREND']?.includes(chart?.type)}
                isShowReversedY={chart?.type === 'RANK_TREND'}
              />
              {isChartLoading && <div style={{ position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)' }}><Spinner size="sm" className="text-danger fs-20 align-middle" style={{ width: '50px', height: '50px' }}></Spinner></div>}
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isOpenImportMediaNews}
          centered={true}
          size="md"
          scrollable={false}
        >
          <ModalHeader toggle={() => setIsOpenImportMediaNews((_prev) => false)}>
            <>{t("Button Import Bulk Articles")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div style={{ minHeight: "170px" }}>
              <ImportMediaArticleForm
                operators={operators}
                triggerRefresh={triggerRefresh}
              />
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isOpenImportNews}
          centered={true}
          size="md"
          scrollable={false}
        >
          <ModalHeader toggle={() => setIsOpenImportNews((_prev) => false)}>
            <>{t("Button Import Article")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div style={{ minHeight: "170px" }}>
              <ImportArticleForm
                operators={operators}
                categories={boostingCategories}
                triggerRefresh={triggerRefresh}
              />
            </div>
          </ModalBody>
        </Modal>

        <ModalConfirm
          header={t('Button Delete News')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />

      </div >
    </React.Fragment >
  );
};

export default TrackingNewsList;